import React, { useEffect } from "react";
import { Navbar } from "@/components/marketing/Navbar";
import { Footer } from "@/components/marketing/Footer";

export function MarketingLayout({ children }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <main className="pt-16">{children}</main>
      <Footer />
    </div>
  );
}

export function Section({ children, className = "", dark = false, id }) {
  return (
    <section id={id} className={`py-20 lg:py-28 ${dark ? "bg-sp-navy text-white" : ""} ${className}`}>
      <div className="sp-container">{children}</div>
    </section>
  );
}
